import styled from "styled-components";

export const Container = styled.div`
    position: relative;
    display: inline-block;
`

export const ThumbnailImage = styled.img`
    width: 150px;
    height: auto;
    cursor: pointer;
    position: relative;
    transition: transform 0.3s;
    transform-origin: center center;

    &:hover {
        transition: transform 0.3s ease 0s;
    }
`

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 20;
`;

export const ModalContent = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background: white;
    border-radius: 8px;
    padding: 60px 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    transition: width 0.3s ease, height 0.3s ease;
    height: ${ ({ contentHeight }) => contentHeight }px;
    width: ${ ({ contentWidth }) => contentWidth }px;

    img {
        transform: ${({ rotation, imageScaled }) => `rotate(${rotation}deg) scale(${imageScaled ? 1.5 : 1})`};
        transition: transform 0.3s ease;
        user-select: none;
        max-width: 100%;
        max-height: 100%;
        z-index: 25;
        cursor: ${({ imageScaled }) => (imageScaled ? "zoom-out" : "zoom-in")};
    }
`;

export const ControllerContainer = styled.div`
    display: flex;
    gap: 10px;
    z-index: 21;
    position: absolute;
    top: 10px;  
    left: 50%;
    transform: translateX(-50%);
`;